var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 193,
    viewBox: "0 0 192 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 96.5C0 43.4807 42.9807 0.5 96 0.5C149.019 0.5 192 43.4807 192 96.5C192 149.519 149.019 192.5 96 192.5C42.9807 192.5 0 149.519 0 96.5Z",
    fill: "url(#paint0_linear_1443_31939)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.172 103.999L154.556 104C156.208 104 156.541 101.749 155.038 101.062L111 81.4998V38.0411C111 36.4308 108.848 35.9024 108.105 37.3309L90.2414 71.7274L70.4466 62.6355C68.5529 61.8707 67.3898 63.4127 68.0326 64.738L79.8282 89H37.4445C35.7917 89 35.4586 91.2533 36.9617 91.9407L81 111.499V154.959C81 156.569 83.1567 157.097 83.8999 155.669L101.764 121.272L121.558 130.364C123.452 131.129 124.615 129.587 123.973 128.262L112.172 103.999Z",
    fill: "#F6F8F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1443_31939",
    x1: 96.0009,
    y1: -17.5017,
    x2: 96.0009,
    y2: 185.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B72D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA43BD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.cd18f855ea19ce2580589488f3d5c252.svg";
export { ForwardRef as ReactComponent };